import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import archiveDataset from 'api/Dataset/archiveDataset';
import deleteDataset from 'api/Dataset/deleteDataset';
import { useState } from 'react';
import switchDatasetStackTerminationProtection from 'api/Dataset/switchDatasetStackTerminationProtection';

interface DeleteDatasetProps {
    label: string;
    datasetUri: string;
    terminationProtection: string;
    onClose?: VoidFunction;
}

export default function useDatasetDelete({
    label,
    datasetUri,
    terminationProtection,
    onClose,
}: DeleteDatasetProps) {
    const client = useClient() as unknown as {
        mutate: (mutate: any) => Promise<any>;
    };
    const { openAlert } = useAlert();

    const [loading, setLoading] = useState(false);

    const switchTermination = async () => {
        const response = await client.mutate(
            switchDatasetStackTerminationProtection(datasetUri),
        );
        return response.errors;
    };

    const datasetDelete = async () => {
        setLoading(true);

        if (terminationProtection === 'true') {
            await switchTermination();
        }
        const response = await client.mutate(deleteDataset(datasetUri));
        if (!response.errors) {
            openAlert({
                message: `Dataset ${label} successfully deleted`,
                severity: 'success',
                path: '/datasets',
            });
        } else {
            openAlert({
                message: 'Something went wrong... Could not delete dataset',
                severity: 'alert',
            });
        }
        if (onClose) onClose();

        setLoading(false);
    };

    const datasetArchive = async () => {
        setLoading(true);

        const response = await client.mutate(archiveDataset(datasetUri));
        if (!response.errors) {
            openAlert({
                message: `Dataset ${label} successfully archived`,
                severity: 'success',
                path: '/datasets',
            });
        } else {
            openAlert({
                message: 'Something went wrong... Could not archive dataset',
                severity: 'alert',
            });

            if (onClose) onClose();
        }
        setLoading(false);
    };
    return { datasetDelete, datasetArchive, loading };
}
